import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickDelete } from "../types";
import { getApi } from "../apiPath";
import { axiosClient, queryClient } from "../clients";

import type { IMembers } from "./routeType";
import { useGetAllMembers } from "./getAll";
import { useGetMember } from "./get";

import { useGetAllUser, useGetUser } from "@/api/users";

const { getPath } = getApi("members.delete");

type IExtractedRouteType = IMembers["memberProfileSingleDelete"];

export type IDeleteMember = IPickDelete<IExtractedRouteType>;

const deleteMember: MutationFunction<
  IDeleteMember["response"],
  IDeleteMember["variables"]
> = ({ memberId }) => {
  return axiosClient.delete(getPath({ memberId }));
};

export const useDeleteMember = createMutation({
  mutationFn: deleteMember,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({ queryKey: useGetAllMembers.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetAllUser.getKey() });
    queryClient.invalidateQueries({ queryKey: useGetUser.getKey() });
    queryClient.invalidateQueries({
      queryKey: useGetMember.getKey({ memberId }),
    });
  },
});
